module.exports = __webpack_public_path__ + "img/halloween.4edf4ba3.png";